// extracted by mini-css-extract-plugin
export default {"data":"ViewEvent_data__U8vl4","pagination":"ViewEvent_pagination__0m1f0","loading":"ViewEvent_loading__QBG1t","no-camera":"ViewEvent_no-camera__L9ioZ"};